import { useState } from 'react';
import { Text } from '@chakra-ui/react';

import { RadioOptionsWithConfirm } from 'shared-components';

import { IQuestion } from '../../../../../../../types';

enum Selection {
  YES = 'Yes',
  NO = 'No'
}

interface IProps {
  setConfirmation: (data: boolean) => void;
}

export const ConfirmationBlock = (props: IProps) => {
  const { setConfirmation } = props;
  const [selection, setSelection] = useState('');

  return (
    <>
      <RadioOptionsWithConfirm
        isInline={true}
        label={`Has your travel status changed since we received your last update?`}
        questions={[
          {
            char: 'Y',
            label: Selection.YES,
            selected: selection === Selection.YES
          },
          {
            char: 'N',
            label: Selection.NO,
            selected: selection === Selection.NO
          }
        ]}
        onClick={(question: IQuestion) => {
          setSelection(question.label);
          if (question.label === Selection.YES) {
            setConfirmation(true);
          } else {
            setConfirmation(false);
          }
          return true;
        }}
      />

      {selection === Selection.NO && (
        <>
          <Text>If nothing has changed with your travel plan and arrival date you can close this window.</Text>
        </>
      )}
    </>
  );
};
